import { render, staticRenderFns } from "./course_header_bar.vue?vue&type=template&id=6583b3e5&scoped=true&"
import script from "./course_header_bar.vue?vue&type=script&lang=js&"
export * from "./course_header_bar.vue?vue&type=script&lang=js&"
import style0 from "./course_header_bar.vue?vue&type=style&index=0&id=6583b3e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6583b3e5",
  null
  
)

export default component.exports